module.exports = __webpack_public_path__ + "static/img/third2_1_7_active.c9e70686.jpg";